module.exports = __webpack_public_path__ + "img/flag-pe.781991b0.svg";